var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"pb-0"},[_vm._v("User Count "+_vm._s(_vm.activePastMonth ? "(Monthly)" : ""))]),_c('div',{staticClass:"user-count"},[_vm._v(_vm._s(_vm.userCount))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }